import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "LITCOHORT",
  title: defineMessage({
    id: "fig.learning.LITCOHORT.title",
    defaultMessage: `Female literacy rate over time and for matched birth cohorts`,
  }),
  caption: defineMessage({
    id: "fig.learning.LITCOHORT.caption",
    defaultMessage: `Adult literacy increases mostly because young literates become adults, not because illiterate adults gain literacy.`,
  }),
  source: defineMessage({
    id: "fig.learning.LITCOHORT.source",
    defaultMessage: `GEM Report team analysis based on household surveys`,
  }),
};
